import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import config from '../../Common/Configurations/APIConfig';
import apiService from "../../Common/Configurations/APIService";
import Header from '../../Common/Layout/Header';
import { useAuth } from '../../Common/Configurations/AuthContext';
import DeleteAlert from '../../Common/Layout/DeleteAlert';
import moment from 'moment';
import PackageTabs from '../AllTabs/PackageTabs';
import { Button, Form, Row, Col, Card, Badge, InputGroup, Modal, Spinner } from 'react-bootstrap';
import LeadChat from '../Marketing/LeadChat';

// --- ENHANCED STYLES FOR COLORFUL & PROFESSIONAL UI ---
const styles = {
    pageBg: { backgroundColor: "#f3f4f6", minHeight: "100vh" },

    // Right Side Colors
    summaryStrip: {
        background: "linear-gradient(135deg, #0ab39c 0%, #405189 100%)",
        color: "#fff",
        borderRadius: "8px"
    },
    gridLabel: {
        color: "#878a99",
        fontSize: "10px",
        textTransform: "uppercase",
        fontWeight: "700",
        letterSpacing: "0.5px"
    },
    gridValue: {
        color: "#212529",
        fontWeight: "600",
        fontSize: "13px"
    },

    // DMC Section
    dmcSidebar: {
        background: "linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%)",
        borderRight: "1px solid #dbeafe",
        padding: "0px",
    },

    // ✅ Selected Item (Modern Gradient Highlight)
    dmcItemActive: {
        background: "linear-gradient(90deg, #2563eb 0%, #1e40af 100%)",
        color: "#ffffff",
        borderLeft: "5px solid #0ea5e9",
        borderRadius: "12px",
        margin: "8px",
        padding: "14px",
        boxShadow: "0 6px 14px rgba(37, 99, 235, 0.25)",
        transition: "all 0.3s ease",
    },

    // ✅ Normal Items (Soft Hover Card)
    dmcItemInactive: {
        background: "#ffffff",
        color: "#1e293b",
        borderRadius: "12px",
        margin: "8px",
        padding: "14px",
        border: "1px solid #e2e8f0",
        transition: "all 0.25s ease",
        cursor: "pointer",
    },

    // Hover effect (Optional)
    dmcItemHover: {
        background: "#f1f5f9",
    },

};

// Helper to get Status Color for Borders
const getStatusColor = (status) => {
    switch (status) {
        case 'NEW': return '#f06548'; // Red
        case 'PROCESSING': return '#f7b84b'; // Yellow/Orange
        case 'WON': return '#0ab39c'; // Green
        case 'LOST': return '#212529'; // Black/Dark
        default: return '#405189'; // Blue
    }
};

const HistoryViewModal = ({ show, onHide, history }) => {
    return (
        <Modal show={show} onHide={onHide} centered scrollable size="md">
            <Modal.Header closeButton className="bg-light">
                <Modal.Title className="fs-15 fw-bold text-uppercase">Lead Interaction History</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                {history && history.length > 0 ? (
                    <div className="acitivity-timeline acitivity-main">
                        {/* REMOVED .reverse() here so it follows the Backend order (Ascending) */}
                        {history.map((log, index) => (
                            <div className="acitivity-item d-flex mb-3" key={index}>
                                {/* ... timeline icons ... */}
                                <div className="flex-grow-1 ms-3 border-bottom pb-3">
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <h6 className="mb-0 fw-bold">Status: {log.status}</h6>

                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-1">


                                        <h6 className="mb-0 fw-bold">Message: {log.message}</h6>

                                        <small className="text-muted">{moment(log.createdDate).format("DD MMM, HH:mm")}</small>
                                    </div>

                                    <small className="fw-medium text-primary">
                                        <i className="ri-user-star-line me-1"></i> Updated by: {log.userName || "Unknown"}
                                    </small>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className="text-center text-muted">No history logs found.</p>
                )}
            </Modal.Body>
        </Modal>
    );
};

// --- Connect DMC Modal (Unchanged) ---
const ConnectDmcModal = ({ show, onHide, lead, userId, cid, onSubmit }) => {
    const { user } = useAuth();
    const [dmcs, setDmcs] = useState([]);
    const [selected, setSelected] = useState([]);
    const [search, setSearch] = useState("");

    useEffect(() => {
        if (show && cid) {
            const fetchDmcs = async () => {
                try {
                    const res = await apiService.getAll(`${config.GETDMCS}/${cid}`);
                    console.log("Fetched DMCs:", res);
                    setDmcs(Array.isArray(res) ? res : res.data || []);
                } catch (error) { console.error("Error loading DMCs", error); }
            };
            fetchDmcs();
        }
    }, [show, cid]);

    const handleToggle = (id) => {
        setSelected(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);
    };

    // const handleSend = () => {
    //     const payloads = selected.map(dmcId => ({
    //         senderId: userId,
    //         receiverId: dmcId,
    //         enquiryType: "PACKAGE",
    //         referenceId: lead.leadId,
    //         sourceName: "Internal Broadcast",
    //         leadStatus: "NEW",
    //         senderStatus: "SENT",
    //         name: `${user?.companyname}`,
    //         email: `${user?.email}`,
    //         phoneNumber: `${user?.phoneNumber}`,
    //         description: `Request for ${lead.name}`,
    //         serviceDetails: { ...lead.serviceDetails }
    //     }));
    //     onSubmit(payloads);
    // };
    const handleSend = () => {
    const payloads = selected.map(dmcId => {
        // Find the DMC object to get its Admin User ID
        const selectedDmc = dmcs.find(d => d.companyId === dmcId);
        
        return {
            senderId: userId,
            // CHANGE: Pass User ID instead of Company ID
            receiverId: selectedDmc?.supplierAdminUserId, 
            enquiryType: "PACKAGE",
            referenceId: lead.leadId,
            sourceName: "Internal Broadcast",
            leadStatus: "NEW",
            senderStatus: "SENT",
            name: `${user?.companyname}`,
            email: `${user?.email}`,
            phoneNumber: `${user?.phoneNumber}`,
            description: `Request for ${lead.name}`,
            serviceDetails: { ...lead.serviceDetails }
        };
    });
    onSubmit(payloads);
};

    return (
        <Modal show={show} onHide={onHide} centered size="xl">
            <Modal.Header closeButton style={{ backgroundColor: '#405189' }}>
                <Modal.Title className="fs-16 fw-bold text-uppercase text-white">
                    <i className="ri-earth-line me-2"></i> Broadcast to Partners
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0">
                <Row className="g-0" style={{ minHeight: "500px" }}>
                    <Col md={3} className="bg-light border-end p-4">
                        <h6 className="fw-bold text-muted mb-4 small text-uppercase">Destination Brief</h6>
                        <div className="p-3 bg-white rounded shadow-sm border-start border-4 border-info mb-3">
                            <small className="text-muted d-block" style={{ fontSize: '10px' }}>TARGET LOCATION</small>
                            <h5 className="mb-0 fw-bold text-dark">{lead?.destination}</h5>
                        </div>
                    </Col>
                    <Col md={9} className="p-4 bg-white">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h6 className="fw-bold text-dark mb-0">Select Suppliers <Badge bg="success" className="ms-2">{selected.length}</Badge></h6>
                            <Form.Control size="sm" style={{ width: '250px' }} placeholder="Search DMCs..." onChange={e => setSearch(e.target.value)} />
                        </div>
                        <div className="row g-3 overflow-auto" style={{ maxHeight: '400px' }}>
                            {dmcs.filter(d => d.companyName?.toLowerCase().includes(search.toLowerCase())).map(d => {
                                const isSelected = selected.includes(d.companyId);
                                return (
                                    <Col md={4} key={d.companyId}>
                                        <div onClick={() => handleToggle(d.companyId)}
                                            className={`p-3 rounded-3 border cursor-pointer position-relative h-100 ${isSelected ? 'shadow-sm' : ''}`}
                                            style={{
                                                backgroundColor: isSelected ? "#eef4ff" : "#fff",
                                                borderColor: isSelected ? "#405189" : "#eee",
                                                borderWidth: isSelected ? "2px" : "1px"
                                            }}>
                                            <div className="d-flex align-items-center">
                                                <div className={`avatar-sm rounded-circle d-flex align-items-center justify-content-center me-3 ${isSelected ? 'bg-primary text-white' : 'bg-light text-muted'}`}>
                                                    <i className="ri-building-line"></i>
                                                </div>
                                                <div className="text-truncate">
                                                    <h6 className="mb-0 fw-bold text-truncate" style={{ fontSize: '13px' }}>{d.brandName || d.companyName}</h6>
                                                    <small className="text-muted" style={{ fontSize: '11px' }}>{d.destinations || "Global"}</small>
                                                </div>
                                            </div>
                                            {isSelected && <i className="ri-checkbox-circle-fill text-primary position-absolute top-0 end-0 m-2 fs-16"></i>}
                                        </div>
                                    </Col>
                                );
                            })}
                        </div>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer className="bg-light p-2">
                <Button variant="link" onClick={onHide} className="text-decoration-none text-muted">Close</Button>
                <Button variant="primary" onClick={handleSend} disabled={!selected.length} className="px-4 rounded-pill">Broadcast Request</Button>
            </Modal.Footer>
        </Modal>
    );
};

const EnquiryList = () => {
    const { user, loading } = useAuth();
    const navigate = useNavigate();

    const [lists, setLists] = useState([]);
    const [branchLeads, setBranchLeads] = useState([]);
    const [activeTab, setActiveTab] = useState('leads'); // 'leads' or 'deals'

    const [selectedItem, setSelectedItem] = useState(null);
    const [editData, setEditData] = useState({});
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [isListLoading, setIsListLoading] = useState(false); // New Loading State for List
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showConnectDmc, setShowConnectDmc] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [isChatOpen, setIsChatOpen] = useState(false);
    const [fromDate, setFromDate] = useState(moment().subtract(1, 'months').format('YYYY-MM-DD')); // Default last 30 days
    const [toDate, setToDate] = useState(moment().format('YYYY-MM-DD'));
    const [localSearch, setLocalSearch] = useState("");

    // Fetch Data
    const GetData = async () => {
        if (!user) return;

        try {
            const tabParam = activeTab === 'deals' ? 'DEALS' : 'LEADS';
            const url = `${config.GET_LEADS_BY_TAB}/${user.id}?tabType=${tabParam}&enquiryType=PACKAGE&search=${localSearch}&fromDate=${fromDate}&toDate=${toDate}`;

            const res = await apiService.getAll(url);
            console.log("Fetched Leads/Deals:", res);
            const data = Array.isArray(res) ? res : (res.data || []);
            setLists(data);

            // NOTE: Removed auto-selection so right side stays empty until user clicks.
        } catch (error) {
            console.error(error);
            setLists([]);
        } finally {
            setIsListLoading(false); // Stop loading animation
        }
    };

    const GetBranches = async (leadId) => {
        const res = await apiService.getAll(`${config.GET_BROADCASTS}/${leadId}`);
        console.log("Branch Leads:", res);
        setBranchLeads(Array.isArray(res) ? res : (res.data || []));
    };

    // --- Tab Change Effect ---
    useEffect(() => {
        if (user) {
            // 1. Reset Selection (Clear Right Side)
            setSelectedItem(null);
            // 2. Start Loading State (Clear Left List)
            setIsListLoading(true);
            setLists([]);
            // 3. Fetch New Data
            GetData();
        }
    }, [user, activeTab]);

    const handleSelectItem = (item) => {
        setSelectedItem(item);
        setEditData(item ? { ...item } : {});
        setSelectedBranch(null);
        if (item && activeTab === 'deals') GetBranches(item.leadId);
    };

    const handleSelectBranch = (lb) => {
        setSelectedBranch(lb);
        setIsChatOpen(false);
    };

    const handleLocalChange = (field, value) => {
        setEditData(prev => ({ ...prev, [field]: value }));
    };

    //      const updateCustomerPipeline = async () => {
    //     const payload = {
    //         leadId: selectedItem.leadId,
    //         leadStatus: editData.leadStatus,
    //         callBack: editData.callBack,
    //         // DIRECT OBJECT PASSING
    //         newLog: {
    //             userId: user.id,
    //             userName: user.name,
    //             status: editData.leadStatus,
    //             message: editData.comment || "Status updated"
    //         }
    //     };

    //     try {
    //         await apiService.update(config.UPDATE_LEAD_STATUS, payload);
    //         setEditData(prev => ({ ...prev, comment: "" }));
    //         GetData(); 
    //     } catch (error) { console.error(error); }
    // };
    const updateCustomerPipeline = async () => {
        if (!selectedItem) return;

        const payload = {
            leadId: selectedItem.leadId,
            leadStatus: editData.leadStatus,
            callBack: editData.callBack,
            // The newLog object used by your Backend logic
            newLog: {
                userId: user.id,
                userName: user.name,
                status: editData.leadStatus,
                message: editData.comment || "Status updated"
            }
        };

        try {
            // 1. Call the API
            const res = await apiService.update(config.UPDATE_LEAD_STATUS, payload);

            if (res) {
                // 2. Clear the comment box locally
                setEditData(prev => ({ ...prev, comment: "" }));

                // 3. Refresh the entire list from the server
                // This updates the 'lists' state
                await GetData();

                // 4. CRITICAL: Update the 'selectedItem' state manually 
                // so that the "View History" modal sees the new log immediately.
                const updatedHistoryEntry = {
                    ...payload.newLog,
                    createdDate: new Date().toISOString()
                };

                setSelectedItem(prev => ({
                    ...prev,
                    leadStatus: editData.leadStatus,
                    callBack: editData.callBack,
                    // Append the new log to the existing history array
                    history: prev.history ? [...prev.history, updatedHistoryEntry] : [updatedHistoryEntry]
                }));

            }
        } catch (error) {
            console.error("Update error:", error);

        }
    };

    const handleBroadcast = async (payloads) => {
        await Promise.all(payloads.map(p => apiService.create(config.CREATELEAD, p)));
        setShowConnectDmc(false);
        GetBranches(selectedItem.leadId);
    };

    const filteredData = lists.filter(item => item.name?.toLowerCase().includes(searchTerm.toLowerCase()));

    // Icon Helper
    const getSourceIcon = (source) => {
        const s = source?.toLowerCase() || "";
        if (s.includes("facebook")) return { icon: "ri-facebook-fill", bg: "#e8f1f9", color: "#1877f2" };
        if (s.includes("whatsapp")) return { icon: "ri-whatsapp-line", bg: "#e6fffa", color: "#25d366" };
        if (s.includes("website")) return { icon: "ri-global-line", bg: "#e0f2ff", color: "#00a3ff" };
        return { icon: "ri-user-line", bg: "#f3f4f6", color: "#6b7280" };
    };

    if (loading) return <div className="p-5 text-center">Loading Dashboard...</div>;

    return (
        <div id="layout-wrapper" style={styles.pageBg}>
            <Header User={user} activeSection="packages" />
            <HistoryViewModal
                show={showHistoryModal}
                onHide={() => setShowHistoryModal(false)}
                history={selectedItem?.history} // This now receives the updated history
            />
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <PackageTabs pageName="ENQUIRIES" />

                        {/* --- MAIN CONTAINER --- */}
                        <div className="row mt-3 g-0 shadow-lg rounded-4 overflow-hidden border border-light" style={{ height: '82vh', backgroundColor: "#fff" }}>

                            {/* --- 1. LEFT SIDEBAR (Colorful List) --- */}
                            <div className="col-lg-3 border-end d-flex flex-column h-100" style={{ backgroundColor: "#fcfcfc" }}>
                                <div className="p-3 bg-white border-bottom sticky-top">


                                    {/* Tabs */}
                                    <div className="nav nav-pills nav-justified bg-light p-1 rounded-3 mb-3">
                                        <div
                                            className={`nav-link py-1 small fw-bold cursor-pointer ${activeTab === 'leads' ? 'bg-white shadow-sm text-primary' : 'text-muted'}`}
                                            onClick={() => setActiveTab('leads')}
                                        >Leads</div>
                                        <div
                                            className={`nav-link py-1 small fw-bold cursor-pointer ${activeTab === 'deals' ? 'bg-white shadow-sm text-primary' : 'text-muted'}`}
                                            onClick={() => setActiveTab('deals')}
                                        >Deals</div>
                                    </div>

                                    {/* <InputGroup size="sm" className="bg-light rounded-pill border">
                                        <InputGroup.Text className="bg-transparent border-0 ps-3 text-muted"><i className="ri-search-2-line"></i></InputGroup.Text>
                                        <Form.Control className="bg-transparent border-0 shadow-none" placeholder="Search..." onChange={(e) => setLocalSearch(e.target.value)} />
                                    </InputGroup> */}


                                    {/* --- DATE FILTERS --- */}
                                    <Row className="g-2 mb-2">
                                        <Col xs={6}>
                                            <Form.Label className="small text-muted mb-0" style={{ fontSize: '9px' }}>FROM</Form.Label>
                                            <Form.Control type="date" size="sm" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                                        </Col>
                                        <Col xs={6}>
                                            <Form.Label className="small text-muted mb-0" style={{ fontSize: '9px' }}>TO</Form.Label>
                                            <Form.Control type="date" size="sm" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                                        </Col>
                                    </Row>

                                    {/* --- SEARCH BAR + BUTTON --- */}
                                    <InputGroup size="sm">
                                        <Form.Control
                                            className="bg-light border-end-0 shadow-none"
                                            placeholder="Search..."
                                            value={localSearch}
                                            onChange={(e) => setLocalSearch(e.target.value)}
                                        />
                                        <Button variant="primary" className="px-3" onClick={GetData}>
                                            <i className="ri-search-line"></i>
                                        </Button>
                                    </InputGroup>
                                </div>

                                {/* List Items or Loader */}
                                <div className="flex-grow-1 overflow-auto p-2 custom-scrollbar">
                                    {isListLoading ? (
                                        <div className="d-flex flex-column align-items-center justify-content-center h-50">
                                            <Spinner animation="border" variant="primary" />
                                            <p className="mt-2 text-muted small">Loading {activeTab}...</p>
                                        </div>
                                    ) : (
                                        filteredData.length === 0 ? (
                                            <div className="text-center mt-5">
                                                <p className="text-muted">No {activeTab} found.</p>
                                            </div>
                                        ) : (
                                            filteredData.map((item) => {
                                                const isActive = selectedItem?.leadId === item.leadId;
                                                const src = getSourceIcon(item.sourceName);
                                                const statusColor = getStatusColor(item.leadStatus);

                                                return (
                                                    <div
                                                        key={item.leadId}
                                                        onClick={() => handleSelectItem(item)}
                                                        className="p-3 mb-2 cursor-pointer position-relative"
                                                        style={{
                                                            // FIXED STYLE LOGIC HERE
                                                            marginBottom: "12px",
                                                            borderRadius: "8px",
                                                            transition: "all 0.2s ease",

                                                            // Dynamic Background
                                                            background: isActive ? "linear-gradient(to right, #eef4ff, #ffffff)" : "#fff",

                                                            // GENERAL BORDER (Top, Right, Bottom)
                                                            borderTop: isActive ? "1px solid #b7cced" : "1px solid #e9ebec",
                                                            borderRight: isActive ? "1px solid #b7cced" : "1px solid #e9ebec",
                                                            borderBottom: isActive ? "1px solid #b7cced" : "1px solid #e9ebec",

                                                            // LEFT BORDER (The one giving issues)
                                                            // We set it explicitly here so it never gets overwritten by a generic 'border' property
                                                            borderLeft: `4px solid ${isActive ? "#405189" : statusColor}`,

                                                            // Shadow
                                                            boxShadow: isActive ? "0 4px 6px rgba(0,0,0,0.05)" : "none"
                                                        }}
                                                    >
                                                        <div className="d-flex">
                                                            {/* LEFT COLUMN: Icon & Source Name */}
                                                            <div className="d-flex flex-column align-items-center me-3" style={{ minWidth: '50px' }}>
                                                                <div className="avatar-sm rounded-circle d-flex align-items-center justify-content-center mb-1"
                                                                    style={{ backgroundColor: src.bg, color: src.color }}>
                                                                    <i className={`${src.icon} fs-20`}></i>
                                                                </div>
                                                                <small className="text-muted text-center fw-bold" style={{ fontSize: '9px', lineHeight: '1.1' }}>
                                                                    {item.sourceName || "Manual"}
                                                                </small>
                                                            </div>

                                                            {/* RIGHT COLUMN: Info Details */}
                                                            <div className="flex-grow-1 overflow-hidden">
                                                                {/* Name & Status */}
                                                                <div className="d-flex justify-content-between align-items-start mb-1">
                                                                    <h6 className="mb-0 text-truncate fw-bold text-dark" style={{ fontSize: '14px', maxWidth: '65%' }} title={item.name}>{item.name}</h6>
                                                                    <span className="badge rounded-pill" style={{ backgroundColor: statusColor, fontSize: '9px' }}>{item.leadStatus}</span>
                                                                </div>
                                                                {/* Contact Info */}
                                                                <div className="mb-2">
                                                                    <div className="d-flex align-items-center text-black small mb-1" title={item.email}>
                                                                        <i className="ri-mail-line me-2 text-primary"></i>
                                                                        <span className="text-truncate">{item.email || "--"}</span>
                                                                    </div>
                                                                    <div className="d-flex align-items-center text-black small" title={item.phoneNumber}>
                                                                        <i className="ri-phone-line me-2 text-success"></i>
                                                                        <span className="text-truncate">{item.phoneNumber || "--"}</span>
                                                                    </div>
                                                                </div>

                                                                {/* Dates (Created & Updated) */}
                                                                <div className="d-flex justify-content-between border-top pt-2 mt-1">
                                                                    <small className="text-black" style={{ fontSize: '10px' }}>
                                                                        Cr: <span className="fw-bold">{moment(item.createdDate).format("DD MMM HH:mm")}</span>
                                                                    </small>
                                                                    <small className="text-black" style={{ fontSize: '10px' }}>
                                                                        Upd: <span className="fw-bold">{moment(item.updatedDate).format("DD MMM HH:mm")}</span>
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        )
                                    )}
                                </div>
                            </div>

                            {/* --- 2. WORKSPACE (RIGHT) --- */}
                            <div className="col-lg-9 d-flex flex-column h-100" style={{ backgroundColor: "#f8f9fa" }}>
                                {selectedItem ? (
                                    <>
                                        {/* HEADER - Gradient Blue/Teal */}
                                        <div className="p-4 shadow-sm d-flex justify-content-between align-items-center bg-white border-bottom" style={styles.summaryStrip}>
                                            <div className="d-flex align-items-center">
                                                <div className="avatar-md text-white rounded-circle d-flex align-items-center justify-content-center me-3 fw-bold fs-20 shadow-lg"
                                                    style={{ background: "linear-gradient(135deg, #405189 0%, #0ab39c 100%)" }}>
                                                    {selectedItem.name?.charAt(0)}
                                                </div>
                                                <div>
                                                    <h4 className="fw-bold mb-1 text-dark">{selectedItem.name}</h4>
                                                    <div className="d-flex align-items-center text-white">
                                                        <i className="ri-phone-line me-1 text-success"></i> {selectedItem.phoneNumber || "--"}
                                                        <span className="mx-2 text-black">|</span>
                                                        <i className="ri-mail-line me-1 text-primary"></i> {selectedItem.email}
                                                        <span className="mx-2 text-black">|</span>
                                                        <i className="ri-map-pin-line me-1 text-danger"></i> {selectedItem.enquiryType || "Unknown"}
                                                        <span className="mx-2 text-black">|</span>
                                                        <i className="ri-calendar-line me-1 text-info"></i> {moment(selectedItem.createdDate).format("DD MMM YYYY")}
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="d-flex gap-2">
                                                {activeTab === 'leads' ? (
                                                    <>
                                                        <Button variant="success" size="sm" className="rounded-pill px-3 fw-bold" onClick={() => window.open(`https://web.whatsapp.com/send?phone=${selectedItem.phoneNumber}`)}><i className="ri-whatsapp-line me-1"></i> WhatsApp</Button>
                                                        <Button variant="primary" size="sm" className="rounded-pill px-3 fw-bold" onClick={() => window.location.href = `mailto:${selectedItem.email}`}><i className="ri-mail-line me-1"></i> Email</Button>
                                                        <Button variant="danger" size="sm" className="rounded-circle avatar-xs p-0" onClick={() => { setItemToDelete(selectedItem.leadId); setShowDelete(true); }}><i className="ri-delete-bin-line"></i></Button>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Button variant="primary" size="sm" className="shadow-sm" onClick={() => navigate('/createPackage', { state: { leadId: selectedItem.leadId } })}><i className="ri-add-line"></i> Create own Package</Button>
                                                        <Button variant="info" size="sm" className="text-white shadow-sm" onClick={() => navigate('/createAipackage', { state: { leadId: selectedItem.leadId } })}><i className="ri-magic-line"></i> Generate AI Package</Button>
                                                        <Button variant="dark" size="sm" className="shadow-sm" onClick={() => setShowConnectDmc(true)}><i className="ri-shake-hands-line me-1"></i> Connect DMC</Button>
                                                    </>
                                                )}

                                            </div>
                                        </div>

                                        <div className="p-2 overflow-auto flex-grow-1">
                                            <Row className="gy-4">

                                                {/* REQUIREMENTS CARD */}
                                                <Col md={9}>
                                                    <Card className="border-0 shadow-sm rounded-3 h-70 overflow-hidden">
                                                        <Card.Body className="p-0">


                                                            {/* Grid - Alternating Colors */}
                                                            <div className="p-4 bg-white">
                                                                <h6 className="fw-bold text-dark mb-3 text-uppercase small ls-1">Detailed Requirements</h6>
                                                                <div className="border rounded overflow-hidden">
                                                                    <Row className="g-0">
                                                                        {Object.entries(selectedItem.serviceDetails || {}).map(([key, value], index) => {
                                                                            const displayKey = key.replace(/([A-Z])/g, ' $1').trim();
                                                                            const isBoolean = value?.toString().toLowerCase() === "true" || value?.toString().toLowerCase() === "false";
                                                                            const isPositive = value?.toString().toLowerCase() === "true";

                                                                            return (
                                                                                <Col xs={6} md={3} key={key} className={`p-3 border-bottom ${index % 4 !== 3 ? 'border-end' : ''}`} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#fcfcfc' }}>
                                                                                    <div style={styles.gridLabel}>{displayKey}</div>
                                                                                    {isBoolean ? (
                                                                                        <Badge bg={isPositive ? "success" : "light"} className={`mt-1 ${isPositive ? "" : "text-muted border"}`}>
                                                                                            {isPositive ? "YES" : "NO"}
                                                                                        </Badge>
                                                                                    ) : (
                                                                                        <div style={styles.gridValue} className="mt-1 text-truncate" title={value?.toString()}>{value?.toString() || "-"}</div>
                                                                                    )}
                                                                                </Col>
                                                                            );
                                                                        })}
                                                                    </Row>
                                                                    <div className="px-4 py-3 bg-white border-bottom">
                                                                        <div className="d-flex">
                                                                            <i className="ri-double-quotes-l text-primary fs-20 me-2 opacity-50"></i>
                                                                            <p className="mb-0 text-black fst-bold">{selectedItem.description || "No specific customer requirements."}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>

                                                {/* ACTION SIDEBAR */}
                                                <Col md={3}>
                                                    <Card className="shadow-none border rounded-3 mb-3">
                                                        <Card.Header className="bg-light py-2 d-flex justify-content-between align-items-center">
                                                            <h6 className="mb-0 fw-bold small text-primary">STATUS CONTROL</h6>
                                                            {/* --- VIEW HISTORY ICON --- */}
                                                            <Link to="#" onClick={() => setShowHistoryModal(true)} title="View Audit Trail"><i className="ri-history-line fs-16 text-muted">View History</i></Link>
                                                        </Card.Header>
                                                        <Card.Body className="p-3">
                                                            <Form.Group className="mb-2"><Form.Label className="text-muted small fw-bold">STATUS</Form.Label><Form.Select size="sm" value={editData.leadStatus || ""} onChange={e => handleLocalChange('leadStatus', e.target.value)}><option value="NEW">NEW</option><option value="PROCESSING">PROCESSING</option><option value="FOLLOW_UP">FOLLOW UP</option><option value="WON">WON</option><option value="LOST">LOST</option></Form.Select></Form.Group>
                                                            <Form.Group className="mb-2"><Form.Label className="text-muted small fw-bold">NEXT CALL</Form.Label><Form.Control size="sm" type="datetime-local" value={editData.callBack ? moment(editData.callBack).format("YYYY-MM-DDTHH:mm") : ""} onChange={e => handleLocalChange('callBack', e.target.value)} /></Form.Group>

                                                            {/* --- NEW COMMENT FIELD --- */}
                                                            <Form.Group className="mb-2">
                                                                <Form.Label className="text-muted small fw-bold">NOTE / COMMENT</Form.Label>
                                                                <Form.Control as="textarea" rows={2} size="sm" placeholder="Type status update..." value={editData.comment || ""} onChange={e => handleLocalChange('comment', e.target.value)} />
                                                            </Form.Group>

                                                            <Button variant="primary" size="sm" className="w-100 fw-bold mt-2" onClick={updateCustomerPipeline}>Update Status</Button>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                                {/* DMC SECTION WITH COLORS */}
                                                {activeTab === 'deals' && (
                                                    <Col md={12}>
                                                        <Card
  className="shadow-lg border-0 rounded-4 overflow-hidden"
  style={{
    height: "450px",
    background: "#ffffff",
  }}
>

                                                            <Row className="g-0 h-100">
                                                                {/* Colored Dark Sidebar */}
                                                                <Col md={3} style={styles.dmcSidebar} className="h-100 overflow-auto">
                                                                    <div
                                                                        className="p-3 border-bottom"
                                                                        style={{
                                                                            background: "linear-gradient(90deg, #0ea5e9, #2563eb)",
                                                                            borderTopLeftRadius: "16px",
                                                                        }}
                                                                    >
                                                                        <h6 className="text-white fw-bold mb-0 text-uppercase">
                                                                            Connected DMCs{" "}
                                                                            <span className="text-light">({branchLeads.length})</span>
                                                                        </h6>
                                                                    </div>

                                                                    <div className="vstack">
                                                                        {branchLeads.map(lb => {
                                                                            const isSelected = selectedBranch?.leadId === lb.leadId;
                                                                            return (
                                                                                <div
                                                                                    key={lb.leadId}
                                                                                    onClick={() => handleSelectBranch(lb)}
                                                                                    className="p-3 cursor-pointer transition-all"
                                                                                    style={isSelected ? styles.dmcItemActive : styles.dmcItemInactive}
                                                                                >
                                                                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                                                                        <span className="fw-bold fs-13">{lb.companyName}</span>
                                                                                        {isSelected && <i className="ri-arrow-right-s-line"></i>}
                                                                                    </div>
                                                                                    <Badge
                                                                                        style={{
                                                                                            backgroundColor: isSelected ? "#38bdf8" : "#94a3b8",
                                                                                            fontSize: "11px",
                                                                                            padding: "6px 10px",
                                                                                            borderRadius: "20px",
                                                                                        }}
                                                                                    >
                                                                                        {lb.senderStatus}
                                                                                     </Badge>

                                                                                </div>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                </Col>

                                                                {/* Chat/Content Area */}
                                                                <Col md={9} className="bg-white h-100 d-flex flex-column">
                                                                    {selectedBranch ? (
                                                                        isChatOpen ? (
                                                                            <LeadChat
                                                                                leadId={selectedBranch.leadId}
                                                                                title={selectedBranch.companyName}
                                                                                user={user}
                                                                                type="AGENT"
                                                                                onClose={() => setIsChatOpen(false)}
                                                                            />
                                                                        ) : (
                                                                            <>
                                                                                <div className="p-4 border-bottom bg-soft-light d-flex justify-content-between align-items-center">
                                                                                    <div className="d-flex align-items-center">
                                                                                        <div className="avatar-sm bg-primary rounded-circle d-flex align-items-center justify-content-center me-3 text-white fw-bold">
                                                                                            {selectedBranch.companyName.charAt(0)}
                                                                                        </div>
                                                                                        <div>
                                                                                            <h5 className="mb-0 fw-bold text-dark">{selectedBranch.companyName}</h5>
                                                                                            <small className="text-muted">Active Negotiation</small>
                                                                                        </div>
                                                                                    </div>
                                                                                    <Button variant="primary" className="px-4 shadow-sm rounded-pill" onClick={() => setIsChatOpen(true)}>
                                                                                        <i className="ri-chat-3-line me-2"></i> Open Chat
                                                                                    </Button>
                                                                                </div>
                                                                                <div
  className="p-5 d-flex flex-column align-items-center justify-content-center h-100"
  style={{
    background: "linear-gradient(180deg, #f8fafc, #ffffff)",
  }}
>

                                                                                    <img src="https://cdn-icons-png.flaticon.com/512/2065/2065224.png" alt="Chat" width="80" className="opacity-25 mb-4" />
                                                                                    <h5 className="fw-bold" style={{ color: "#1e293b" }}>
  Supplier Interaction Hub
</h5>

<p className="text-muted text-center" style={{ maxWidth: "420px" }}>
  Start chatting with <b>{selectedBranch.companyName}</b> to exchange itineraries,
  negotiate prices, and confirm bookings.
</p>

                                                                                </div>
                                                                            </>
                                                                        )
                                                                    ) : (
                                                                        <div className="h-100 d-flex flex-column align-items-center justify-content-center">
                                                                            <i className="ri-store-line fs-48 text-muted opacity-25 mb-3"></i>
                                                                            <p className="text-muted">Select a supplier from the left to view details.</p>
                                                                        </div>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </Card>
                                                    </Col>
                                                )}
                                            </Row>
                                        </div>
                                    </>
                                ) : (
                                    // EMPTY STATE / WELCOME SCREEN
                                    <div className="h-100 d-flex flex-column align-items-center justify-content-center">
                                        <div className="mb-3 avatar-lg bg-white rounded-circle shadow-sm d-flex align-items-center justify-content-center">
                                            <i className="ri-inbox-line fs-36 text-primary"></i>
                                        </div>
                                        <h5 className="text-dark fw-bold">Welcome to Enquiry Manager</h5>
                                        <p className="text-muted">Select a {activeTab} from the inbox to display details.</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <ConnectDmcModal show={showConnectDmc} onHide={() => setShowConnectDmc(false)} lead={selectedItem} userId={user?.id} cid={user?.cid} onSubmit={handleBroadcast} />
                <DeleteAlert show={showDelete} handleClose={() => setShowDelete(false)} handleDelete={async () => { await apiService.remove(config.DELETELEAD, itemToDelete); setShowDelete(false); GetData(); setSelectedItem(null); }} />
            </div>
        </div>
    );
};

export default EnquiryList;